import { AxiosError } from 'axios'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import * as yup from 'yup'
import { Product } from 'src/api/models'
import { useForm } from 'src/forms'
import { setApiErrors } from 'src/forms/errors'
import { skuit } from 'src/services/skuit'
import toast from 'react-hot-toast'
import { handleErrorMessage, Notification } from 'src/components/Notification'

const useStyles = makeStyles(() => ({
  form: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
}))

interface ProductProps {
  name: string
}

const productSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
})

interface Props {
  open: boolean
  handleClose: () => void
  onSave?: () => void
  update?: boolean
  product?: Product
}

export const ProductDialog = (props: Props) => {
  const { open, handleClose, onSave, update, product } = props
  const classes = useStyles()

  const onSubmit = (data: ProductProps) => {
    let func = skuit.sc.products.create
    let action = 'creat'
    if (update) {
      func = (data: ProductProps) => skuit.sc.products.patch(product?.guid || '', data)
      action = 'updat'
    }
    func(data)
      .then((newProduct: Product) => {
        handleClose()
        if (onSave) {
          onSave()
        }
        toast.success(() => (
          <Notification
            message={`Successfully ${action}ed Product: ${newProduct.name}`}
            newObject={newProduct}
          />
        ))
      })
      .catch((error: AxiosError) => {
        handleErrorMessage(error, action, 'Product')
        setApiErrors(formData.setError, error)
      })
  }

  const { Form, Field, data: formData } = useForm(productSchema)

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <Form formProps={{ className: classes.form }} onSubmit={onSubmit}>
        <DialogTitle>Create Product</DialogTitle>
        <DialogContent>
          <Field
            name="name"
            defaultValue={product?.name}
            renderField={({ name, value, setValue, error }) => (
              <TextField
                id={name}
                name={name}
                label="Name"
                error={!!error}
                helperText={error}
                fullWidth
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setValue(name, e.target.value)
                }
                value={value || ''}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary" variant="contained" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
